var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from 'elements/Loading';
import { Form } from 'components';
import { FieldType } from 'elements';
import { rules } from 'helpers/Validation';
import { Iconos } from '../../../elements/IconosApp';
var OperationLinesForm = /** @class */ (function (_super) {
    __extends(OperationLinesForm, _super);
    function OperationLinesForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'businessUnit',
                column: 'businessUnit_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .required(),
                size: 4,
                options: _this.props.store.businessUnits.data.map(function (item) {
                    // console.log('item', item)
                    return {
                        value: String(item.id),
                        name: item.name
                    };
                })
            },
            {
                name: 'description',
                type: FieldType.TextArea,
                rules: rules()
                    .string(),
                size: 12,
            },
            {
                name: 'icon',
                type: FieldType.Icon,
                rules: rules()
                    .string(),
                size: 12,
                icons: Iconos
            }
        ];
        return _this;
    }
    OperationLinesForm.prototype.render = function () {
        var operationLine = this.props.operationLine;
        var operationLines = this.props.store.operationLines;
        // console.log('Iconos en render', Iconos)
        // console.log('this.props.businessUnits', this.props.businessUnits)
        return (React.createElement("div", null,
            React.createElement(Form, { loading: ['post@operationlines/', 'put@operationlines/'], fields: this.fields, values: operationLine, store: operationLines })));
    };
    OperationLinesForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.operationLines.read(props.match.params.id).then(function (operationLine) { return ({ operationLine: operationLine }); })
                : undefined,
            props.store.businessUnits.read(),
            props.store.receipLayouts.read(),
            props.store.taxes.read()
        ]; }),
        observer
    ], OperationLinesForm);
    return OperationLinesForm;
}(Component));
export default OperationLinesForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/container/OperationLinesForm.tsx
// module id = 1269
// module chunks = 0